




export function safeSetTimeout(handler, timeout)
{
	//Log.Error("TIMING", "setTimeout() discouraged, use timing context!");
	
	// // track callers
	// let caller = this.GetCallerLocation();
	// let n = (this.setTimeoutUsage.get(caller) || 0) +1;
	// this.setTimeoutUsage.set(caller, n);

	return mySetTimeout(handler, timeout);
}

// override default functions and give error (later fix to throw exception)


export function safeClearTimeout(handle)
{
	//Log.Error("TIMING", "clearTimeout() discouraged, use timing context!");
	return myClearTimeout(handle);
}

export function safeSetInterval(handler, timeout)
{
	
	//Log.Error("TIMING", "setInterval() discouraged, use timing context!");
	
	// // track callers
	// let caller = this.GetCallerLocation();
	// let n = (this.setIntervalUsage.get(caller) || 0) +1;
	// this.setIntervalUsage.set(caller, n);

	return mySetInterval(handler, timeout);
}

export function safeClearInterval(handle)
{
	//Log.Error("TIMING", "clearInterval() discouraged, use timing context!");
	return myClearInterval(handle);
}

function GetCallerLocation()
{
	let error = null;
	try { throw Error('') } catch(err) { error = err; }

	let caller_line = error.stack.split("\n")[3];
	let index = caller_line.indexOf("at ");
	let clean = caller_line.slice(index+3, caller_line.length);

	return {
		stack: error.stack,
		caller: clean
	};
}


// save original function
export const mySetTimeout = window.setTimeout.bind(window);
export const myClearTimeout = window.clearTimeout.bind(window);
export const mySetInterval = window.setInterval.bind(window);
export const myClearInterval = window.clearInterval.bind(window);

// override "safe" functions
(window.setTimeout as any) = safeSetTimeout;
window.clearTimeout = safeClearTimeout;
window.setInterval = safeSetInterval;
window.clearInterval = safeClearInterval;




// export class Timing
// {
// 	protected mySetTimeout;
// 	protected myClearTimeout;

// 	protected mySetInterval;
// 	protected myClearInterval;

// 	protected setTimeoutUsage: Map<string, number> = new Map<string, number>();
// 	protected setIntervalUsage: Map<string, number> = new Map<string, number>();

// 	protected constructor()
// 	{
// 		this.mySetTimeout = window.setTimeout.bind(window);
// 		this.myClearTimeout = window.clearTimeout.bind(window);
// 		this.mySetInterval = window.setInterval.bind(window);
// 		this.myClearInterval = window.clearInterval.bind(window);


// 		// override default functions and give error (later fix to throw exception)
// 		(window.setTimeout as any) = (handler, timeout) => {
// 			//Log.Error("TIMING", "setTimeout() discouraged, use timing context!");
			
// 			// // track callers
// 			// export caller = this.GetCallerLocation();
// 			// let n = (this.setTimeoutUsage.get(caller) || 0) +1;
// 			// this.setTimeoutUsage.set(caller, n);

// 			return this.mySetTimeout(handler, timeout);
// 		}

// 		window.clearTimeout = (handle) => {
// 			//Log.Error("TIMING", "clearTimeout() discouraged, use timing context!");
// 			return this.myClearTimeout(handle);
// 		}

// 		window.setInterval = (handler, timeout) => {
			
// 			//Log.Error("TIMING", "setInterval() discouraged, use timing context!");
			
// 			// // track callers
// 			// let caller = this.GetCallerLocation();
// 			// let n = (this.setIntervalUsage.get(caller) || 0) +1;
// 			// this.setIntervalUsage.set(caller, n);

// 			return this.mySetInterval(handler, timeout);
// 		}

// 		window.clearInterval = (handle) => {
// 			//Log.Error("TIMING", "clearInterval() discouraged, use timing context!");
// 			return this.myClearInterval(handle);
// 		}
// 	}





// 	protected static instance: Timing = new Timing();
// 	public static get Instance(): Timing
// 	{
// 		return this.instance;
// 	}

// 	public get SetTimeout()
// 	{
// 		return this.mySetTimeout;
// 	}

// 	public get ClearTimeout()
// 	{
// 		return this.myClearTimeout;
// 	}

// 	public get SetInterval()
// 	{
// 		return this.mySetInterval;
// 	}

// 	public get ClearInterval()
// 	{
// 		return this.myClearInterval;
// 	}
// }

// {
// 	let earlyInstance = Timing.Instance;
// }